import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * PREVIOUS / NEXT, AND WHICH ACCOUNTS YOU ARE LOOKING AT.
 *
 * THE BUG THIS EXISTS TO FIX. The agent's portfolio table already cut its
 * list into pages of 25 and drew page one. Nothing on the screen ever drew
 * the controls, and nothing ever changed the page number away from 1. So an
 * agent holding 800 accounts could reach twenty-five of them. Not hidden
 * behind a scroll -- there was no way to get to account 26 at all. Every
 * agent with a real book has been working off the first page.
 *
 * It is written once, here, because the admin portal had a working version
 * of exactly this strip built into its filter bar and the agent portal had
 * none. Two copies is how they came to differ in the first place.
 */
export interface AccountsPagerProps {
  page: number;
  pageCount: number;
  total: number;
  /** First row number on this page, 1-based. 0 when nothing matches. */
  from: number;
  /** Last row number on this page. */
  to: number;
  onPage: (page: number) => void;
  /** What is being counted, for the sentence on the left. */
  noun?: string;
  className?: string;
}

export const AccountsPager: React.FC<AccountsPagerProps> = ({
  page,
  pageCount,
  total,
  from,
  to,
  onPage,
  noun = 'accounts',
  className = '',
}) => {
  const btn =
    'inline-flex items-center gap-1 px-2.5 py-2 bg-white border border-slate-200 rounded-lg font-bold text-slate-700 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition cursor-pointer';

  return (
    <div
      className={`px-3 py-2.5 border-t border-slate-100 flex flex-wrap items-center justify-between gap-2 bg-slate-50/60 text-xs ${className}`}
    >
      <span className="text-slate-600">
        {total === 0 ? (
          `No ${noun} match`
        ) : (
          <>
            Showing <strong className="text-slate-900">{from}</strong>–
            <strong className="text-slate-900">{to}</strong> of{' '}
            <strong className="text-slate-900">{total.toLocaleString('en-IN')}</strong> {noun}
          </>
        )}
      </span>

      <div className="flex items-center gap-1.5">
        {/*
          First and Last are here because an agent with 800 accounts is 32
          pages from the end, and getting there one Next at a time is not a
          reasonable thing to ask of somebody standing in the street.
        */}
        <button
          type="button"
          onClick={() => onPage(1)}
          disabled={page <= 1}
          className={btn}
          title="First page"
        >
          <span>First</span>
        </button>
        <button
          type="button"
          onClick={() => onPage(page - 1)}
          disabled={page <= 1}
          className={btn}
        >
          <ChevronLeft className="w-3.5 h-3.5" />
          <span>Previous</span>
        </button>

        <span className="px-2 font-semibold text-slate-700 whitespace-nowrap">
          Page {page} of {pageCount}
        </span>

        <button
          type="button"
          onClick={() => onPage(page + 1)}
          disabled={page >= pageCount}
          className={btn}
        >
          <span>Next</span>
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
        <button
          type="button"
          onClick={() => onPage(pageCount)}
          disabled={page >= pageCount}
          className={btn}
          title="Last page"
        >
          <span>Last</span>
        </button>
      </div>
    </div>
  );
};

export default AccountsPager;
